import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:window.localStorage.getItem('token'),
    user: window.localStorage.getItem('user')?JSON.parse(window.localStorage.getItem('user')):null,
    roleList:window.localStorage.getItem('roleList')?JSON.parse(window.localStorage.getItem('roleList')):[],
    dictionaries: {},//所有字典项
  },
  mutations: {
    setDictionary(state, data) {
      state.dictionaries[data.code] = data.list;
    },
    setToken(state, data) {
      state.token = data;
    },
    setRoleList(state,data){
      window.localStorage.setItem('roleList', JSON.stringify(data));
      state.roleList = data;
    },
    setLogin(state, data) {
      window.localStorage.setItem('user', JSON.stringify(data));
      state.token = data.token;
      state.sessionID = data.authorize.sessionId;
      state.user = data;
    },
  },
  actions: {
    setDictionary({commit}, data) {
      commit('setDictionary', data)
    },
    setRoleList({commit},data){
      commit('setRoleList',data)
    },
    setLogin({commit}, data) {
      commit('setLogin', data)
    },
    setToken({commit}, data) {
      commit('setToken', data)
    },
  },
  modules: {
  }
})
